import React, { useEffect, useRef, useState } from "react";
import { KTSVG } from "../../../_metronic/helpers";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { updateTimeEntryArchiveAsync, resetSelectedRecordObjectInState } from "./TimeEntryArchiveSlice";
import { TimeEntryArchiveInitialsForAdd, TimeEntryArchiveInitialsForUpdate } from "./interfaces/TimeEntryArchiveClass";
import { ShowToast } from '../../../common/Toastr';
import { getValueFromResource } from "../../../common/timeLiveFunction";
export const TimeEntryArchiveForm = (props: any) => {
    const { t, oncloseModal } = props;
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(TimeEntryArchiveInitialsForAdd);  
    const [isChangelogModalOpen, setIsChangelogModalOpen] = useState<boolean>(false);
    const [reasonForChange, setReasonForChange] = useState<string>('');

    const { selectedRecord, timeEntryArchiveList } = useAppSelector((state) => state.timeEntryArchive);
    
    const preferences = useAppSelector((state: any) => state.preference || state.timesheetPreference);
    const { allowZeroHoursInTimesheet,cultureInfoName,decimalPlaces, IsTimesheetChangelogEnabled } = useAppSelector((state) => state.globalState);

    const dispatch = useAppDispatch();

    useEffect(() => {
        let stateItem: any = {};
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(TimeEntryArchiveInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            });
            setCurrentFieldsData(stateItem);
        } else {
            setCurrentFieldsData(TimeEntryArchiveInitialsForAdd);
        }
    }, [selectedRecord]);

    const handleTextChange = (e: any) => {
        setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value) });
    };  
    const executeSave = (reason: string = '') => {
        const payload = {
            ...currentFieldsData,
            Reason: reason || currentFieldsData.Reason || ''
        };
        dispatch(updateTimeEntryArchiveAsync(payload))
            .unwrap()
            .then((originalPromiseResult) => {
                oncloseModal();
                dispatch(resetSelectedRecordObjectInState());
                setIsChangelogModalOpen(false);
                setReasonForChange('');
                ShowToast("Entry(s) Updated Succesfully", 'Success', "success", "toast-top-right");
            })
            .catch((rejectedValueOrSerializedError) => {
                ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
            });
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        const isEditingExisting = Object.keys(selectedRecord).length > 0;    
        if (IsTimesheetChangelogEnabled && isEditingExisting && !reasonForChange) {
            setIsChangelogModalOpen(true);
            return;
        }
        if (isEditingExisting) {
            executeSave(reasonForChange);
        } else {
           
        }
    };

    const handleChangelog = () => {
        if (!reasonForChange.trim()) {
            ShowToast('Warning', 'Please enter reason for change', 'warning', 'toast-top-right');
            return;
        }
        executeSave(reasonForChange);
    };

    return (
        <>
            <div className="modal drawer-overlay" style={{ display: 'block' }}>
           <div className="modal-dialog">
                    <div className="modal-content">
                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                            <h5 className="modal-title mainHeading">
                                {getValueFromResource('Update Time Entry Archive', dispatch, t)}
                            </h5>
                            <div
                                className="btn btn-icon btn-sm btn-active-secondary ms-2"
                                aria-label="Close"
                                onClick={oncloseModal}
                            >
                                <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-1x"
                                />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <label className="form-label">
                                        {getValueFromResource('Submitted', dispatch, t)}
                                    </label>
                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                        <input className="form-check-input h-20px w-30px" type="checkbox" checked={currentFieldsData.Submitted || false} id="Submitted" onChange={handleTextChange} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">
                                        {getValueFromResource('Approved', dispatch, t)}
                                    </label>
                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                        <input className="form-check-input h-20px w-30px" type="checkbox" checked={currentFieldsData.Approved || false} id="Approved" onChange={handleTextChange} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer" style={{ padding: '.6rem .6rem' }}>
                            <button
                                type="button"
                                className="btn btn-secondary btn-bs-btn-font-weight btn-sm p-2 fs-7"
                                onClick={oncloseModal}
                            >
                                {getValueFromResource('Cancel', dispatch, t)}
                            </button>
                            <button type="button"
                                className="btn btn-primary btn-bs-btn-font-weight btn-sm p-2 fs-7"
                                onClick={handleSubmit}
                            >
                                {getValueFromResource('Save', dispatch, t)}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
           {isChangelogModalOpen && (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }}>
        <div className="modal-dialog">
            <div className="modal-content">
                <div className="modal-header py-3">
                     <h5 className="headerTitle m-0">
                        {getValueFromResource('Reason', dispatch, t) || 'Reason'}
                    </h5>
                    <div
                        className="btn btn-icon btn-sm btn-active-secondary ms-2"
                        onClick={() => {
                            setIsChangelogModalOpen(false);
                            setReasonForChange(''); 
                        }}
                    >
                        <KTSVG
                            path="/media/icons/duotune/arrows/arr061.svg"
                            className="svg-icon svg-icon-1x"
                        />
                    </div>
                </div>
                 <div className="modal-body pt-3 pb-4 px-4">
                        <p className="text-gray-700 required fs-6 mb-3 text-start">
                     {getValueFromResource('Please enter reason for change', dispatch, t) || 'Please enter reason for change'}
                                            </p>
                    
                    <textarea
                        className="form-row form-control"
                        rows={3}
                        value={reasonForChange}
                        onChange={(e) => setReasonForChange(e.target.value)}
                        placeholder={getValueFromResource('Enter reason...', dispatch, t) || 'Enter reason...'}
                    />
                </div>
                <div className="modal-footer py-2">
                    <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        onClick={() => {
                            setIsChangelogModalOpen(false);
                            setReasonForChange(''); 
                        }}
                    >
                        {getValueFromResource('Cancel', dispatch, t)}
                    </button>
                                <span
                                    style={{
                                        display: "inline-block",
                                        cursor: !reasonForChange.trim() ? "not-allowed" : "default"
                                    }}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        onClick={handleChangelog}
                                        disabled={!reasonForChange.trim()}
                                        style={{
                                            opacity: !reasonForChange.trim() ? 0.45 : 1,
                                            pointerEvents: !reasonForChange.trim() ? "none" : "auto"
                                        }}
                                    >
                                        {getValueFromResource('Ok', dispatch, t) || 'Ok'}
                                    </button>
                                </span>
                </div>
            </div>
        </div>
    </div>
)}
        </>
    );
};
